import React, { useState } from "react";
import { Card } from "react-bootstrap";
import "./collapsible-card.css";

const CollapsibleCard = ({
  title,
  subtitle,
  headerIcon,
  headerIconColor,
  headerBackgroundColor,
  borderColor,
  isExpanded: controlledIsExpanded,
  onToggle,
  bannerContent,
  children,
  isControlled = false,
}) => {
  const [internalIsExpanded, setInternalIsExpanded] = useState(true);

  const isExpanded = isControlled ? controlledIsExpanded : internalIsExpanded;

  const handleToggle = () => {
    if (isControlled && onToggle) {
      onToggle();
    } else {
      setInternalIsExpanded(!internalIsExpanded);
    }
  };

  return (
    <Card
      className="collapsible-card"
      style={{
        borderColor: borderColor || "#e0e0e0",
        borderWidth: "1px",
        borderStyle: "solid",
        marginBottom: "20px",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <Card.Header
        className="collapsible-card-header"
        style={{
          backgroundColor: headerBackgroundColor || "#f5f5f5",
          cursor: "pointer",
          padding: "16px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        onClick={handleToggle}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {headerIcon && (
            <div
              className="header-icon"
              style={{
                color: headerIconColor || "#000",
                fontSize: "24px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {headerIcon}
            </div>
          )}
          <div>
            <h5 style={{ margin: 0, fontWeight: 600, fontSize: "16px" }}>
              {title}
            </h5>
            {subtitle && (
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  color: "#666",
                  marginTop: "4px",
                }}
              >
                {subtitle}
              </p>
            )}
          </div>
        </div>
        <div
          style={{
            transition: "transform 0.3s ease",
            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="#666"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </Card.Header>

      {bannerContent && isExpanded && (
        <div className="collapsible-card-banner">{bannerContent}</div>
      )}

      {isExpanded && (
        <Card.Body
          className="collapsible-card-body"
          style={{ padding: "20px" }}
        >
          {children}
        </Card.Body>
      )}
    </Card>
  );
};

export default CollapsibleCard;
